@if (grunddata) {
<form [formGroup]="form">
    @if (isKundorder()) {
    <rask-selector
        class="col-7"
        label="Kund"
        aid="kund"
        [reverseLookup]="false"
        [search]="searchKund"
        [viewFormatter]="kundViewFormatter"
        formControlName="kund"
        [rule]="validation.kund"
        [required]="true">
    </rask-selector>
    }
    <rask-selector
        class="col-3"
        label="Måttslag"
        aid="mattslag"
        formControlName="mattslag"
        [formatter]="mattslagFormatter"
        [viewFormatter]="mattslagFormatter"
        [rule]="validation.mattslag"
        [required]="true"
        [values]="grunddata.mattslagList">
    </rask-selector>
    @if (!isKundorder()) {
    <rask-header size="3" underline>{{"TERMINALORDER_DETAIL_ORDERRAD" | translate}}</rask-header>
    }
    @if (isKundorder()) {
    <rask-header size="3" underline>{{"KUNDORDER_DETAIL_ORDERRAD" | translate}}</rask-header>
    }
    <rask-kundorderrad-create
        [kundorderTyp]="kundorderTyp"
        [modalMode]="true"
        [enableCommands]="false"
        (modelCreated)="onModelCreated($event)"
        [rootForm]="form"
        [kundorder]="kundorder">
    </rask-kundorderrad-create>
</form>
}
<div class="buttons">
    <rask-save-button [disabled]="!canSave()" (click)="save()"></rask-save-button>
    <rask-button color="secondary" (click)="close()">Avbryt</rask-button>
</div>